import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatYouGet } from './components/WhatYouGet';
import { OfferSection } from './components/OfferSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FooterCTA } from './components/FooterCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Inject Meta Pixel
    const pixelScript = document.createElement('script');
    pixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1225428543097695');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(pixelScript);
    // Inject UTMIFY Script 1
    const utmifyScript1 = document.createElement('script');
    utmifyScript1.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript1.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript1.async = true;
    utmifyScript1.defer = true;
    document.head.appendChild(utmifyScript1);
    // Inject UTMIFY Script 2
    const utmifyScript2 = document.createElement('script');
    utmifyScript2.innerHTML = `
      window.pixelId = "69c6a39ac2cace08567a215b";
      var a = document.createElement("script");
      a.setAttribute("async", "");
      a.setAttribute("defer", "");
      a.setAttribute("src", "https://cdn.utmify.com.br/scripts/pixel/pixel.js");
      document.head.appendChild(a);
    `;
    document.head.appendChild(utmifyScript2);
    return () => {
      document.head.removeChild(pixelScript);
      document.head.removeChild(utmifyScript1);
      document.head.removeChild(utmifyScript2);
    };
  }, []);
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-gold-500/30" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <WhatYouGet data-id="element-5" />
        <OfferSection data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Guarantee data-id="element-8" />
        <FAQ data-id="element-9" />
      </main>
      <FooterCTA data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}